<script setup lang="ts">
import { onMounted, provide } from "vue";
import { useAuthStore } from "./stores/authStore";
import { MfaAPI } from "./services";

provide("mode", import.meta.env.MODE);

const authStore = useAuthStore();

const authHeader = (config: any) => {
  config.headers.Authorization = `Bearer ${authStore.authState.idToken}`;
  return config;
};

onMounted(() => {
  console.log(`✨ RAM Unify v${import.meta.env.RAM_APP_VERSION}`);
  MfaAPI.interceptors.request.use(authHeader);
});
</script>

<template>
  <div class="h-full w-full font-inter">
    <router-view />
  </div>
</template>
